import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const AGENCY_QUERY_KEY = 'sales-agencies'

export const useGetAgencies = (params?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [AGENCY_QUERY_KEY],
    queryFn: async () => {
      const { data, error } = await supabaseApi.from('sales_agencies').select('*')
      if (error) throw error
      return data
    },
    enabled: params?.enabled,
  })
}
